import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ClientUserService, ProUserService } from '../../services';

/* eslint-disable */
export const VerifyAccountGuard: CanActivateFn = (route, state) => {
    const clientUser = inject(ClientUserService).isVerified();
    const proUser = inject(ProUserService).isVerified();
    const isUserVerified = clientUser || proUser;

    if (isUserVerified) {
        return true;
    } else {
        inject(Router).navigateByUrl('/verify/phone');
        return false;
    }
};
